"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.COLOR_CODES = void 0;
exports.COLOR_CODES = {
    THEME_GREEN: '#008272',
    GREY: '#797979',
};
